import { E_RISK_TYPE } from 'interfaces';
import { ReactElement } from 'react';

export type HeatmapCellType = {
    value: number;
    isVisible: boolean;
    color: string;
    clickable: boolean;
    percentile: HeatmapPercentile;
    tooltip: () => ReactElement;
};

export type HeatmapCellPosition = {
    row: number;
    column: number;
};

export type HeatmapPercentile = {
    label: string;
    type: 'green' | 'red' | 'white';
    color: string;
    percentile: number;
};

export enum HeatmapScoreType {
    RISK = 'RISK',
    PULSE = 'PULSE',
    PULSE_INTENSITY = 'PULSE_INTENSITY'
}

export type HeatmapRisk = {
    id: number;
    title: string;
};

export enum E_GRAPH_DATA_TYPE {
    RISK = 'risk',
    PULSE = 'pulse',
    PULSE_INTENSITY = 'pulse_intensity'
}

export const HEATMAP_SCORE_TYPE_TO_DATA_TYPE: Record<HeatmapScoreType, E_GRAPH_DATA_TYPE> = {
    [HeatmapScoreType.RISK]: E_GRAPH_DATA_TYPE.RISK,
    [HeatmapScoreType.PULSE]: E_GRAPH_DATA_TYPE.PULSE,
    [HeatmapScoreType.PULSE_INTENSITY]: E_GRAPH_DATA_TYPE.PULSE_INTENSITY,
}

export const HEATMAP_SCORE_TYPE_TO_TITLE: Partial<Record<HeatmapScoreType, string>> =  {
    [HeatmapScoreType.RISK]: 'Composite',
    [HeatmapScoreType.PULSE]: 'Pulse',
};

export const HEATMAP_RISK_TYPE_TO_TITLE: Partial<Record<E_RISK_TYPE, string>> = {
    [E_RISK_TYPE.CLIENT_FACING_INDICATORS]: 'Focus Risks',
    [E_RISK_TYPE.DIMENSIONS]: 'Fundamental Risks',
};

